/*
 * API lấy dữ liệu cho bảng lịch sử sửa chữa.
 * pvduy 02/02/2020
 */
import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class UsageHistoryAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "UsageHistory";
  /**
   * nnhphong - load du lieu cho grid chi tiet dieu chuyen
   * @param {*} transferID
   */
  loadAssetTransfer(transferID) {
    let request = {
      url: [this.getAPIUrl() + "/transfer-asset-history"].join("/"),
      data: transferID,
    };

    return httpClient.postAsync(request);
  }
  /**
   * nnhphong - load du lieu cho grid chi tiet  mat huy thanh ly (quan ly theo so luong)
   * @param {*} typeOcc
   * @param {*} assetID
   */
  loadLostCancelLiquidatedAsset(assetStatus, assetID) {
    let request = {
      url: [this.getAPIUrl() + "/asset-by-quantity", assetStatus].join("/"),
      data: assetID,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm thực hiện lấy full trường phục vụ cho các form tài sản theo số lượng
   * @param {*} payload
   * @returns
   */
  getUsageHistoryFullFieldByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "usage-history-full-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm thực hiện lấy quá trình sử dụng(cấp phát/thu hồi/điều chuyển) tài sản của đơn vị
   * @param {*} payload
   * @returns
   */
  getOrganizationUnitUsageHistory(payload) {
    let request = {
      url: [this.getAPIUrl(), "organization-unit-usagehistory"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm thực hiện xóa bỏ nghiệp vụ(cấp phát/thu hồi/điều chuyển) tài sản của đơn vị
   * kiểm tra nếu đã phát sanh nghiệp vụ tiếp theo trả về mã lỗi
   * @param {*} payload
   * @returns
   */
  deleteOrganizationUnitUsageHistory(usageHistory) {
    var payload = {
      Entity: usageHistory,
    };
    let request = {
      url: [this.getAPIUrl(), "delete-organization-unit-usagehistory"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm thực hiện check tồn trước khi lấy data
   * @param {*} payload
   * @returns
   */
  async getUsageHistoryTotalByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "usage-history-total-by-assetid"].join("/"),
      data: payload,
    };

    let res = await httpClient.postAsync(request);

    return res;
  }

  /**
   * Lấy lịch sử sử dụng theo nhân viên
   * created by ntphong 25/3/2021
   */
  getUsageHistoryByEmployeePaging(payload) {
    let request = {
      url: [this.getAPIUrl(), "usage-history-employee"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Xóa quá trình sử dụng theo nhân viên
   * created by ntphong 25/3/2021
   */
  deleteUsageHistoryByEmployee(usageHistoryID) {
    let request = {
      url: [this.getAPIUrl(), "delete-usage-history-by-employee", usageHistoryID].join("/"),
    };

    // Call api
    return httpClient.deleteAsync(request);
  }

  getUsageHistoryByLocationId(payload) {
    let request = {
      url: [this.getAPIUrl(), "get-usagehistory-by-location-id"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  async getUsageHistoryByUsageHistoryID(ids) {
    let request = {
      url: [this.getAPIUrl(), "get-usage-history-by-usage-history-id"].join("/"),
      data: ids,
    };

    // Call api
    return await httpClient.postAsync(request);
  }

  async loadNearestUsageHistoryByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "nearest-usage-history", payload.OccurenceType, payload.AssetID].join(
        "/",
      ),
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Thực hiện lấy ngày
   * @param {*} payload
   * @returns
   */
  async loadNearestUsageHistoryByListAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "nearest-usage-history-by-list-assetid"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }
}

export default new UsageHistoryAPI();
